<template>
  <div class="fixed bottom-4 pt-10 right-4 z-8 flex flex-col gap-2 overflow-y-auto max-h-[85vh]">
    <div
      class="absolute top-0 right-0 text-blue-9 text-sm rounded bg-blue-2 px4 py1 shadow-md shadow-blue-500/30"
      v-if="alertStore.messages.length"
      @click="alertStore.clearAll()"
    >
      <span>清除所有</span>
      <wd-icon name="delete-thin"></wd-icon>
    </div>
    <!-- <TransitionGroup name="slide-fade" tag="div"> -->
    <div
      v-for="msg in alertStore.messages"
      :key="msg.id"
      class="flex items-center p-2 bg-blue-2 rounded shadow-md shadow-blue-500/30 w-80 mb-3"
    >
      <wd-icon name="notification" custom-class="text-amber text-xl"></wd-icon>
      <div
        class="flex-1 mx-3"
        :class="{ 'text-blue-9': msg.type === 'info', 'text-[red]': msg.type === 'error' }"
      >
        <div>{{ msg.content }}</div>
        <div class="text-xs mt-1">{{ msg.date }}</div>
      </div>
      <wd-button
        type="icon"
        icon="close-circle"
        v-if="msg.closable"
        custom-class="close-btn"
        @click="() => alertStore.removeMessage(msg.id)"
      ></wd-button>
    </div>
    <!-- </TransitionGroup> -->
  </div>
</template>

<script lang="ts" setup>
import { useAlertStore } from '@/store/index'
const alertStore = useAlertStore()
// onMounted(() => {

// })
// onBeforeUnmount(() => {
//   uni.$off('WsOnMessage')
// })
</script>

<style lang="scss" scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.close-btn {
  width: 20px !important;
  height: 20px !important;
  font-size: 18px !important;
}
</style>
